import React from 'react'
import AppBar from '@mui/material/AppBar'
import Toolbar from '@mui/material/Toolbar'
import { useSelector } from 'react-redux'
import { Box } from '@mui/material'
import CustomSearchBar from '../CustomSearchBar'
import { SectionTitle } from '../ProjectInputs/ProjectInputs'
import { themeConfig } from '../../config/theme.config'
const multimodalLogo = new URL(
  '../../../../images/illustrations/SEMCOG-MultiTool-Logo.svg',
  import.meta.url
)
const semcogLogo = new URL(
  '../../../../images/icons/SEMCOG-Logo-Lockup.svg',
  import.meta.url
)

function Header() {
  const { activeStep } = useSelector((state) => state.mainTool)
  return (
    <AppBar
      position="static"
      sx={{
        backgroundColor: 'transparent',
        backgroundImage: 'linear-gradient(to bottom , white,white, #F7F6F1)'
      }}
    >
      {' '}
      <Toolbar
        sx={{
          minHeight: '0px !important',
          pt: '8px',
          pb: '8px',
          display: 'flex',
          justifyContent: 'space-between'
        }}
      >
        {' '}
        <Box
          sx={{
            height: '45px',
            display: 'flex',
            gap: '5px',
            alignItems: 'center',
            width: '300px'
          }}
        >
          <img
            src={multimodalLogo}
            style={{
              width: '40px',
              height: '40px',
              objectFit: 'cover'
            }}
          />
          <SectionTitle
            fontWeight={900}
            fontSize={32}
            color={themeConfig.semcogBlack}
          >
            Multimodal Tool
          </SectionTitle>
        </Box>
        {activeStep === 0 && <CustomSearchBar />}
        <Box
          sx={{
            height: '38px',
            display: 'flex',
            alignItems: 'center',
            width: '300px',
            justifyContent: 'flex-end'
          }}
        >
          <img
            src={semcogLogo}
            style={{
              maxHeight: '50%',
              objectFit: 'cover',
              width: '150px'
            }}
          />
        </Box>
      </Toolbar>
    </AppBar>
  )
}

export default Header
